import React from 'react'
import { Record } from '../../../models'
import { batchUpdateRecords, toastSuccess } from '../../../api'
import { PaginatedTableContract } from '../../common'
import { InvalidSupplierRow } from './row'

interface InvalidSupplierProps extends PaginatedTableContract {
    resources: {
        records: Record[]
    }
}

export const InvalidSupplierTable = (props: InvalidSupplierProps) => {
    const { resources, callbacks } = props
    const { records } = resources
    const { setReload } = callbacks

    const handleSubmit = (oldValue: string, newValue: string) => {
        const params = {
            phone_number: {
                oldValue,
                newValue
            }
        }

        batchUpdateRecords(params)
            .then(response => {
                if (response.status === 200 && setReload) {
                    toastSuccess('Phone Number Updated')
                    setReload(true)
                }
            })
            .catch(() => {})
    }

    return (
        <table className='table'>
            <tbody>
                <tr>
                    <th>Record ID</th>
                    <th>Name</th>
                    <th>Street</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Country</th>
                    <th colSpan={2}>Phone</th>
                </tr>
                {records.map(record =>
                    <InvalidSupplierRow
                        key={record.id}
                        onSubmit={handleSubmit}
                        record={record} />
                )}
            </tbody>
        </table>
    )
}
